var menuData = {
  name: "menu",
  data: [{
    fontFamily: "MicrosoftYaHei",
    fontSize: 14,
    fontColor: "#6a6a6a",
    arrowWidth: 8,
    arrowHeight: 8,
    arrowRightDistance: 16,
    arrowColor: "#333333"
  }]
};
export default menuData;